<template>
	<div class="u-flex">
		<div v-if="!this.$store.state.posts" class="u-align-center">
			<icon class="c-icon-loading" use="loading"></icon>
		</div>
		<div v-if="this.$store.state.posts">
			<div v-if="this.type === 'list'">
				<post v-for="post in this.$store.state.posts" 
                      :key="post.slug" :title="post.title.rendered" 
                      :author="getUserName(post.author)" 
                      :date="formatDate(post.date)" 
                      :preview="post.excerpt.rendered" 
                      :slug="post.slug" 
                      :previewImage="post._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url"></post>
			</div>
			<div v-if="this.type === 'single'">
				<post v-if="singlePost" 
                      :title="singlePost.title.rendered" 
                      :author="getUserName(singlePost.author)" 
                      :date="formatDate(singlePost.date)" 
                      :content="singlePost.content.rendered" 
                      :slug="singlePost.slug" 
                      :fullImage="singlePost._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"></post>
			</div>
		</div>
	</div>
</template>

<script>
// Import components
import icon from '@/components/icons/icons'
import post from '@/components/post/post'

// Import SVG icons
import loading from './../../assets/img/loading.svg'

export default {
	name: 'posts',
	props: {
		type: {
			type: String,
			required: true
		}
	},
	components: {
		icon,
		post
	},
	data() {
		return {
			singlePost: null
		}
	},
	created() {
		if(this.type === 'single') {
                  // If we're viewing component in single post mode, grab the post and if not found send to 404 page
			this.getSinglePost().then(null, () => {
				this.$router.push({name: 'pageNotFound'})
			});
		}
	},
	methods: {
		// Formats date into presentable format
		formatDate: function(date) {
			var dateObj = new Date(date)
			var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
			return dateObj.getDate() + ' ' + monthNames[dateObj.getMonth()] + ' ' + dateObj.getFullYear();
		},
		getSinglePost: function() {
			return new Promise((resolve, reject) => {	
				this.$store.dispatch('getPosts').then(() => {
					var foundPost = false;
					this.$store.state.posts.filter((post) => {
						if(post.slug === this.$route.params.slug) {
							this.singlePost = post;
							foundPost = true;
						}
					});
					foundPost ? resolve() : reject();
				})
			})
		},
		// Returns user name when passed ID
		getUserName: function(userId) {
			var username = 'unknown';
			this.$store.state.authors.filter(function(user) {
				if(user.id === userId) {
					username = user.name
				}
			});
			return username;
		}
	}
}
</script>



// WEBPACK FOOTER //
// posts.vue?066ce65d